export const SOURCE_STEP = 'source' as const
export const FORM_STEP = 'form' as const
export const FREE_CITATIONS = 'free_citations' as const
export const PREMIUM_CITATIONS = 'premium_citations' as const
export const FOLDERS = 'folders' as const
export const CITATIONS_DASHBOARD = 'citations_dashboard' as const

export const SOURCE_PAGE = 'source_page'
export const SEARCH_PAGE = 'search_page'

export const autociteSources = ['film', 'website']
